// The Auth0 SDK writes this cookie when it stores tokens and removes it on logout.
const SESSION_COOKIE_RE = /(?:^|;\s*)auth0\.[^=;]+\.is\.authenticated=/;

/**
 * Best guess, before Auth0 answers, that this load ends signed in: an existing session or the
 * redirect back from a login. It only picks a loading screen — it never grants access.
 */
export function isLikelySignedIn(): boolean {
  // Mirrors auth0-react's unexported `hasAuthParams`, minus `error=` (that load shows the error screen).
  const params = new URLSearchParams(window.location.search);
  const isLoginCallback = params.has('code') && params.has('state');
  return isLoginCallback || SESSION_COOKIE_RE.test(document.cookie);
}
